// extracted by mini-css-extract-plugin
export default {"mainWrap":"noDataFound_mainWrap__qp+6a"};